// Preview identity belongs to this URL/tab. Never store it in the sign-in session.
export function previewLocation(pathname = window.location.pathname) {
  const match = pathname.match(/^\/student-preview\/sections\/(\d+)\/students\/(\d+)(?=\/|$)/);
  if (!match) return null;
  return { basename: match[0], sectionId: Number(match[1]), studentId: Number(match[2]) };
}

export function studentPreviewHref(sectionId: number, studentId: number) {
  return `/student-preview/sections/${sectionId}/students/${studentId}/v2/student?section=${sectionId}`;
}

export function previewEndpoint(preview: NonNullable<ReturnType<typeof previewLocation>>) {
  return `/api/v2/sections/${preview.sectionId}/students/${preview.studentId}/preview/`;
}

export const previewNoticeEvent = 'student-preview-notice';
export function previewNotice(message = 'This preview is read only. Changes and submissions are disabled.') {
  window.dispatchEvent(new CustomEvent(previewNoticeEvent, { detail: message }));
}

export function previewReadOnlyError() {
  const detail = 'This preview is read only. Changes and submissions are disabled.';
  previewNotice(detail);
  return Object.assign(new Error(detail), { code: 'STUDENT_PREVIEW_READ_ONLY', response: { status: 403, data: { detail, error: detail } } });
}

export function routePreviewRequest(config: any) {
  const preview = previewLocation();
  if (!preview) return config;
  if ((config.method || 'get').toLowerCase() !== 'get') throw previewReadOnlyError();
  const url = new URL(config.url || '', window.location.origin + '/api/v2/');
  if (url.origin !== window.location.origin) throw previewReadOnlyError();
  const resource = url.pathname.replace(/^\/api\/v2(?=\/)/, '');
  const params: Record<string, any> = {};
  url.searchParams.forEach((value, key) => { params[key] = value; });
  Object.assign(params, config.params || {});
  config.baseURL = '';
  config.url = `${previewEndpoint(preview)}data/`;
  config.params = { ...params, resource };
  return config;
}
